const stopPropagationForKey = (event: React.KeyboardEvent, key: string) => {
  if (event.key === key) {
    event.stopPropagation()
  }
}

export default stopPropagationForKey
